import styles from './card.module.css'
import FadeIn from "@/shared/ui/animations/FadeIn.jsx";
import {toast} from "react-toastify";
export default function Card ({discount, description, isTermsCompleted, promo, noBtn=false}) {
    return (
        <FadeIn>
            <div className={styles.card}>
                <p className={styles.big}>{discount}%</p>
                <h4>{description}</h4>
                {!noBtn && (
                    <button
                        className={`btn btn-red-filled ${styles.btn}`}
                        disabled={!isTermsCompleted}
                        onClick={() => {
                            if(isTermsCompleted) {
                                navigator.clipboard.writeText(promo)
                                toast.success('Промокод скопирован')
                            }
                        }}
                    >
                        {isTermsCompleted ? "Скопировать промокод" : "Условия не выполнены"}
                    </button>
                    )}
            </div>
        </FadeIn>
    )
}